export default __webpack_public_path__ + "static/media/nr3.ec8400df.svg";